// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const FileProperty = {
    file: (value) => {
        return Object.assign(Object.assign({}, value), { type: "file", _visit: function (visitor) {
                return FernIr.FileProperty._visit(this, visitor);
            } });
    },
    fileArray: (value) => {
        return Object.assign(Object.assign({}, value), { type: "fileArray", _visit: function (visitor) {
                return FernIr.FileProperty._visit(this, visitor);
            } });
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "file":
                return visitor.file(value);
            case "fileArray":
                return visitor.fileArray(value);
            default:
                return visitor._other(value);
        }
    },
};
